/* Nurse Hotline constants */

export const HOTLINE_STATUS_LABELS = {
  new: "New",
  in_assessment: "In Assessment",
  decision_pending: "Decision Pending",
  escalated: "Escalated",
  follow_up_required: "Follow-Up Required",
  closed: "Closed",
};

export const HOTLINE_STATUS_COLORS = {
  new: { color: "#06B6D4", bg: "#06B6D414" },
  in_assessment: { color: "#6366F1", bg: "#6366F114" },
  decision_pending: { color: "#F59E0B", bg: "#F59E0B14" },
  escalated: { color: "#EF4444", bg: "#EF444414" },
  follow_up_required: { color: "#0B7E8C", bg: "#0B7E8C14" },
  closed: { color: "#10B981", bg: "#10B98114" },
};

export const DECISION_LABELS = {
  advice_patient: "Advice patient",
  refer_ed: "Refer to Emergency Dept",
  dispatch_ambulance: "Dispatch ambulance",
  transfer_unit: "Transfer to unit",
  teleconsultation_referral: "Teleconsultation referral",
  follow_up_required: "Follow-up required",
  refer_hah: "Refer to H@H Program",
};

export const HOTLINE_ROLES = ["hah_nurse", "hah_coordinator", "care_coordinator", "admin"];
export function canHotline(role) { return HOTLINE_ROLES.includes(role); }
